/**
 * @param {KeyboardEvent} event
 * @param {string} event.key
 * @returns {boolean}
 */
export default ({ key }) => 'ArrowLeft' === key;
